import React, { useState} from 'react';
import { Box, TextField, Button } from '@mui/material';
import { useNavigate} from "react-router-dom";
import { styled } from '@mui/material/styles';

const CssTextField = styled(TextField)({
    minWidth: '125px;',
   '& .MuiInput': {overflow: 'wrap'},
    '& label.Mui-focused': {
    color: '#141419',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#141419',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#717171',
    },
    '&:hover fieldset': {
      borderColor: '#141419',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0A21C0',
    },
  },
})

const buttonStyle = {
    margin: 'auto',
    marginTop: '15px',
    width: 'auto',
    height: 'auto',
    color: 'whitesmoke',
    fontSize: '15px',
    boxShadow: "5",
    backgroundColor: '#141619',
    borderColor: '#141419',
    "&:hover": {
      backgroundColor: '#050A44',
      borderColor: '#141419',
      WebkitTextFillColor: 'white',
      boxShadow: "15",
    },
    "&::after":{
      WebkitTextFillColor: 'white'
    }
  }


const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    function handleLogin(e) {
      e.preventDefault();
      if (username !== '' && password !== ''){
          sessionStorage.setItem("auth", 1)
      }
      navigate("/Upload")
    }

    return (
        <div className='mainPage'>
            <Box
            component="form"
            autoComplete='off'
            className='formContainer'
            onSubmit={handleLogin}
            >
                
                <CssTextField name={'username'} required autoComplete='on' onChange={(event) => setUsername(event.target.value)} label='Username' variant='outlined' size='normal' margin='normal'/>
                <br/>
                <CssTextField name={'username'} required autoComplete='off' type="password" onChange={(event) => setPassword(event.target.value)} label='Password' variant='outlined' size='normal' margin='normal'/>
                <br/>

                <Button type="submit" sx={buttonStyle} variant="outlined">
                  Login
                </Button>

            </Box>
        </div>
    );

}

export default Login;